"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const antd_1 = require("antd");
const moment_1 = __importDefault(require("moment"));
const suiteFormStyle_1 = require("./suiteFormStyle");
const PaymentFormStyle_1 = require("../../paymentForm/PaymentFormStyle");
const validations_1 = require("../../../utils/validations");
const Telephone_1 = __importDefault(require("../../telephone/Telephone"));
const regex_1 = require("../../../utils/regex");
const users_1 = require("../../../utils/users");
require("./customLabel.scss");
const SuiteForm = ({ form, field, guestField, isRequired = false, setIsRequired, formKey = 'suites', }) => {
    const documentTypeHandle = (0, react_1.useCallback)(() => {
        const suitesValues = form.getFieldValue([formKey]);
        suitesValues[field.key].guests[guestField.key].documentGuest = '';
        form.setFieldsValue({ [formKey]: suitesValues });
    }, [form, formKey]);
    const isAllEmpty = () => {
        const guestFieldsToValidate = ['fullname', 'documentGuest', 'birthday', 'email', 'phone'];
        const allFieldsIsEmpty = guestFieldsToValidate.every(fieldName => !form.getFieldValue([formKey, field.key, 'guests', guestField.key, fieldName]));
        setIsRequired(!allFieldsIsEmpty);
        if (allFieldsIsEmpty) {
            form.validateFields([
                [formKey, field.key, 'guests', guestField.key, 'fullname'],
                [formKey, field.key, 'guests', guestField.key, 'documentGuest'],
                [formKey, field.key, 'guests', guestField.key, 'birthday'],
                [formKey, field.key, 'guests', guestField.key, 'email'],
                [formKey, field.key, 'guests', guestField.key, 'phone'],
            ]);
        }
    };
    const validationJustOnceEmail = () => ({
        validator(rule, value) {
            if (!value) {
                return Promise.resolve();
            }
            // verificação com o primeiro hóspede na tela de pagamento
            const firstEmailBooking = (0, users_1.getUserData)().email;
            if (firstEmailBooking === value) {
                return Promise.reject(new Error('E-mail já utilizado no primeiro hóspede'));
            }
            // verificação com o primeiro hóspede na tela de checkin
            const firstEmailCheckin = form.getFieldValue([formKey, field.key, 'emailRequired']);
            if (firstEmailCheckin === value) {
                return Promise.reject(new Error('E-mail já utilizado no primeiro hóspede'));
            }
            const guestEmails = form.getFieldValue([formKey, field.key, 'guests']);
            let foundPreviously = false; // Variável que indica se o e-mail já foi encontrado uma vez
            const foundTheSame = guestEmails.find((guest) => {
                if (value === guest.email) {
                    // se havia sido encontrado uma vez, esta é a segunda e significa que está repetido
                    if (foundPreviously) {
                        return true;
                    }
                    foundPreviously = true;
                }
                return false;
            });
            if (foundTheSame) {
                return Promise.reject(new Error('E-mail já utilizado em outro hóspede'));
            }
            return Promise.resolve();
        },
    });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(antd_1.Col, { style: { marginTop: '20px' }, span: 24 },
            react_1.default.createElement(antd_1.Row, null,
                react_1.default.createElement(antd_1.Col, { flex: "1" },
                    react_1.default.createElement(suiteFormStyle_1.FormItemFormulary, { labelCol: { span: 24 }, name: [guestField.key, 'fullname'], label: "Nome Completo", rules: [
                            () => ({
                                validator(rule, value) {
                                    if (!isRequired) {
                                        return Promise.resolve();
                                    }
                                    const valueTrim = value === null || value === void 0 ? void 0 : value.trim();
                                    if (!valueTrim) {
                                        return Promise.reject(new Error('Por favor informe o nome'));
                                    }
                                    if (!valueTrim.match(regex_1.REGEX_LETTERS_SPACES)) {
                                        return Promise.reject(new Error('Por favor remova os caracteres especiais'));
                                    }
                                    if (!valueTrim.match(regex_1.REGEX_FULL_NAME)) {
                                        return Promise.reject(new Error('Por favor informe o nome completo'));
                                    }
                                    return Promise.resolve();
                                },
                            }),
                        ] },
                        react_1.default.createElement(suiteFormStyle_1.InputStyled, { onChange: isAllEmpty, placeholder: "Nome completo do h\u00F3spede" })))),
            react_1.default.createElement(antd_1.Row, { justify: "space-between" },
                react_1.default.createElement(antd_1.Col, { xs: {
                        span: 24,
                        flex: '1',
                    }, sm: {
                        span: 24,
                        flex: '1',
                    }, lg: 7 },
                    react_1.default.createElement(antd_1.Row, { wrap: false },
                        react_1.default.createElement(suiteFormStyle_1.FormItemFormulary, { style: {
                                width: '90px',
                                maxWidth: '90px',
                                marginRight: '5px',
                                display: 'block',
                            }, labelCol: { span: 24 }, name: [guestField.key, 'documentTypeGuest'], label: "Tipo", initialValue: "CPF" },
                            react_1.default.createElement(PaymentFormStyle_1.SelectStyled, { onChange: () => {
                                    documentTypeHandle();
                                    isAllEmpty();
                                }, size: "large" },
                                react_1.default.createElement(PaymentFormStyle_1.SelectStyled.Option, { value: "CPF" }, "CPF"),
                                react_1.default.createElement(PaymentFormStyle_1.SelectStyled.Option, { value: "RG" }, "RG"),
                                react_1.default.createElement(PaymentFormStyle_1.SelectStyled.Option, { value: "PASSPORT" }, "PASS"))),
                        react_1.default.createElement(antd_1.Col, { flex: "1" },
                            react_1.default.createElement(suiteFormStyle_1.FormItemFormulary, { style: {
                                    flex: '1',
                                }, labelCol: { span: 24 }, name: [guestField.key, 'documentGuest'], label: "Documento", validateTrigger: "onBlur", rules: [
                                    {
                                        required: isRequired,
                                    },
                                    () => ({
                                        validator(rule, value) {
                                            if (!value) {
                                                return Promise.resolve();
                                            }
                                            const docType = form.getFieldValue([
                                                formKey,
                                                field.key,
                                                'guests',
                                                guestField.key,
                                                'documentTypeGuest',
                                            ]);
                                            if (docType === 'CPF') {
                                                if (!(0, validations_1.validateCPF)(value)) {
                                                    return Promise.reject(new Error('Insira um CPF válido'));
                                                }
                                                return Promise.resolve();
                                            }
                                            return Promise.resolve();
                                        },
                                    }),
                                ] }, (() => {
                                switch (form.getFieldValue([formKey, field.key, 'guests', guestField.key, 'documentTypeGuest'])) {
                                    case 'CPF':
                                        return (react_1.default.createElement(suiteFormStyle_1.MaskInputStyled, { onChange: isAllEmpty, type: "tel", mask: "111.111.111-11", placeholder: "XXX.XXX.XXX-XX" }));
                                    case 'RG':
                                        return (react_1.default.createElement(suiteFormStyle_1.MaskInputStyled, { onChange: isAllEmpty, mask: "11.111.111-*", placeholder: "XX.XXXX.XXX-X" }));
                                    case 'PASSPORT':
                                        return react_1.default.createElement(suiteFormStyle_1.InputStyled, null);
                                    default:
                                        return (react_1.default.createElement(suiteFormStyle_1.MaskInputStyled, { onChange: isAllEmpty, type: "tel", mask: "111.111.111-11", placeholder: "XXX.XXX.XXX-XX" }));
                                }
                            })())))),
                react_1.default.createElement(antd_1.Col, { xs: {
                        span: 24,
                        flex: '1',
                    }, sm: {
                        span: 24,
                        flex: '1',
                    }, lg: 7 },
                    react_1.default.createElement(suiteFormStyle_1.FormItemFormulary, { labelCol: { span: 24 }, style: { minWidth: '150px' }, name: [guestField.key, 'birthday'], label: "Data de Nascimento", validateTrigger: "onBlur", rules: [
                            {
                                required: isRequired,
                            },
                            () => ({
                                validator(rule, value) {
                                    if (!value) {
                                        return Promise.resolve();
                                    }
                                    const dateFormat = 'DD/MM/YYYY';
                                    const inputDate = (0, moment_1.default)(value, dateFormat, true);
                                    if (!(0, moment_1.default)(inputDate).isValid()) {
                                        return Promise.reject(new Error('Insira uma data válida'));
                                    }
                                    return Promise.resolve();
                                },
                            }),
                        ] },
                        react_1.default.createElement(suiteFormStyle_1.MaskInputStyled, { onChange: isAllEmpty, type: "tel", mask: "11/11/1111", placeholder: "dd/mm/aaaa", name: "Data de Nascimento Segundo H\u00F3spede" }))),
                react_1.default.createElement(antd_1.Col, { xs: {
                        span: 24,
                        flex: '1',
                    }, sm: {
                        span: 24,
                        flex: '1',
                    }, lg: 7 },
                    react_1.default.createElement(suiteFormStyle_1.FormItemFormulary, { labelCol: { span: 24 }, name: [guestField.key, 'email'], label: "E-mail", rules: [
                            { required: isRequired, message: 'Por favor, insira um E-mail' },
                            { type: 'email', message: 'Por favor, insira um E-mail válido' },
                            validationJustOnceEmail,
                        ] },
                        react_1.default.createElement(suiteFormStyle_1.InputStyled, { onChange: isAllEmpty, placeholder: "exemplo@dominio.com.br" }))),
                react_1.default.createElement(antd_1.Col, { xs: {
                        span: 24,
                        flex: '1',
                    }, sm: {
                        span: 24,
                        flex: '1',
                    }, lg: 7 },
                    react_1.default.createElement("div", { className: "ant-col ant-col-24 ant-form-item-label" },
                        react_1.default.createElement("label", { htmlFor: `${formKey}_${field.key}_guests_${guestField.key}_phone`, className: isRequired ? 'ant-form-item-required' : '', title: "Celular", style: { fontWeight: 500 } }, "Celular")),
                    react_1.default.createElement(Telephone_1.default, { form: form, required: isRequired, onChange: isAllEmpty, ddiFieldName: [formKey, field.key, 'guests', guestField.key, 'ddi'], ddiFormItemProps: {
                            initialValue: '55',
                            name: [guestField.key, 'ddi'],
                        }, phoneFieldName: [formKey, field.key, 'guests', guestField.key, 'phone'], phoneFormItemProps: {
                            name: [guestField.key, 'phone'],
                        }, phoneInputProps: {
                            placeholder: '(XX) XXXXX-XXXX',
                        } }))))));
};
exports.default = SuiteForm;
